var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-inline-icon",class:['ui-inline-icon', 'ui-inline-icon--'+_vm.icon, {'ui-inline-icon--circle': _vm.inCircle}],style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}})}
var staticRenderFns = []

export { render, staticRenderFns }